import React, { createContext, useContext, useState } from 'react';
import DisclaimerModal from '../components/common/DisclaimerModal';

const DisclaimerModalContext = createContext();

export const useDisclaimerModal = () => {
  const context = useContext(DisclaimerModalContext);
  if (!context) {
    throw new Error('useDisclaimerModal must be used within a DisclaimerModalProvider');
  }
  return context;
};

export const DisclaimerModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const showModal = () => setIsOpen(true);
  const hideModal = () => setIsOpen(false);

  return (
    <DisclaimerModalContext.Provider value={{ showModal, hideModal, isOpen }}>
      {children}
      <DisclaimerModal isOpen={isOpen} onClose={hideModal} />
    </DisclaimerModalContext.Provider>
  );
};